import { Password } from "primereact/password";
import { classNames } from "primereact/utils";

export default function FormInputpassword(props) {
  const {
    className,
    setting: { Controller, control, isEdit = true },
    data: {
      uiClassName,
      name,
      placeholder = "",
      disabled = false,
      saveFun = () => {},
    },
  } = props;

  return (
    <>
      <Controller
        key={name}
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <div
            className={classNames(
              "flex align-items-center flex-auto",
              className
            )}
          >
            <Password
              id={field.name}
              className={classNames(
                { "p-invalid": fieldState.invalid },
                "w-full",
                uiClassName
              )}
              {...field}
              value={field.value ? field.value : ""}
              toggleMask
              feedback={false}
              placeholder={placeholder}
              onChange={(e) => field.onChange(e.target.value)}
              onBlur={saveFun}
              disabled={!isEdit || disabled}
            />
          </div>
        )}
      />
    </>
  );
}
